<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "SkupPrometBase"
};
</script>

<style scoped>

</style>
